export default "__VITE_ASSET__0d467f6f__"